import { render, staticRenderFns } from "./BlackFridayIcon.vue?vue&type=template&id=f577021c"
import script from "./BlackFridayIcon.vue?vue&type=script&lang=js"
export * from "./BlackFridayIcon.vue?vue&type=script&lang=js"
import style0 from "./BlackFridayIcon.vue?vue&type=style&index=0&id=f577021c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports